import { Component, EventEmitter, Input, Output } from '@angular/core';
import { trackByRef } from 'src/app/lego-utils';
import { tap } from 'rxjs/operators';
import { PMOrder } from 'src/app/models/domain';
import { PMOrderService } from 'src/app/state';

@Component({
  selector: 'em-workcenter-selector',
  styleUrls: ['./workcenter-selector.component.less'],
  templateUrl: './workcenter-selector.component.html',
  standalone: false,
})
export class WorkcenterSelectorComponent {
  @Output() public readonly selectedPmOrders = new EventEmitter<PMOrder[]>();

  @Input() public loading = false;

  public listOfOptions: PMOrder[] = [];
  public readonly trackByRef = trackByRef;

  public pmOrders$ = this.pmOrderService.pmOrders$.pipe(
    tap((pmOrders) => {
      this.listOfOptions = pmOrders;
      this.selectionChanged(pmOrders);
    })
  );

  public constructor(private readonly pmOrderService: PMOrderService) {}

  public selectionChanged(selected: PMOrder[]) {
    this.selectedPmOrders.emit(selected);
  }
}
